<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Components
	import Icon from '@/Components/Icon.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';

	const dispatch = createEventDispatcher();

	export let sport;
	export let marketTypes;
	export let selectedMarketType;
</script>

<table class="w-full whitespace-nowrap mt-3">
	<thead>
		<tr class="text-xs text-left text-gray-500 uppercase">
			<th class="px-2 pt-3 pb-2 font-medium">Market Types</th>
			<th class="px-2 pt-3 pb-2 font-medium text-left">Label</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-left">Rule</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-left">Rolling Type</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-left">Limit factor</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-center">Cashout</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-center">Pre-Match</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-center">In-Play</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-center">Price Order</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-left">Sport</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-left">EXT ID</th>
			<th class="w-px px-2 pt-3 pb-2 font-medium text-right" />
		</tr>
	</thead>
	<tbody class="bg-white">
		{#each marketTypes as marketType (marketType.id)}
			<tr
				on:click={() => {
					selectedMarketType = marketType;
					dispatch('selected');
				}}
				class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100"
			>
				<td class="py-2.5 px-2 border-t w-72">
					<div class="flex items-center">
						<div class="mr-2 font-semibold">{marketType.name}</div>
					</div>
				</td>
				<td class="px-2 border-t w-72">
					{marketType.label ?? ''}
				</td>
				<td class=" px-2 border-t w-72 max-w-72 flex-wrap text-wrap">
					{marketType.rule ?? ''}
				</td>
				<td class="w-px px-2 border-t">
					{(marketType.rolling_type && marketType.rolling_type.name) ?? ''}
				</td>
				<td class="w-px px-2 border-t">
					{marketType.selection_win_limit_factor}
				</td>
				<td class="w-px px-6 border-t text-center">
					<div class="flex flex-row items-center justify-center">
						<CheckBox disabled bind:checked={marketType.cashout_enabled} />
					</div>
				</td>
				<td class="w-px px-2 border-t text-center">
					<div class="flex flex-row items-center justify-center">
						<CheckBox disabled bind:checked={marketType.traded_pre_match} />
					</div>
				</td>
				<td class="w-px px-2 border-t text-center">
					<div class="flex flex-row items-center justify-center">
						<CheckBox disabled bind:checked={marketType.traded_in_play} />
					</div>
				</td>
				<td class="w-px px-2 border-t text-center">
					<div class="flex flex-row items-center justify-center">
						<CheckBox disabled bind:checked={marketType.price_order} />
					</div>
				</td>
				<td class="w-px px-2 border-t">
					<div class="px-2 py-1 bg-green-500 rounded-md text-light">
						{marketType.sport.name}
					</div>
				</td>
				<td class="w-px px-2 border-t">
					{#if marketType.remote_id}
						<div class="px-2 py-1 bg-blue-500 rounded-md text-light text-center">
							{marketType.remote_id}
						</div>
					{:else if marketType.is_manual}
						<div class="px-2 py-1 bg-orange-500 rounded-md text-light">MANUAL</div>
					{/if}
				</td>
				<td class="w-px px-6 border-t">
					<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
				</td>
			</tr>
		{:else}
			<tr>
				<td class="px-6 py-4 text-center border-t" colspan="12">
					No market types found for {sport.name}.
				</td>
			</tr>
		{/each}
	</tbody>
</table>
